<template>
    <main id="notifications" class="page" role="main">
        <div class="o-wrapper u-m-y16 u-m-y10@m u-m-y6@s">
            <div class="o-grid o-grid--center">
                <div class="o-grid__item u-width-8/12 u-width-full@m">
                    <div class="c-notifications__title u-m-b3">
                        <h4>Your notifications</h4>
                        <a href="#0" @click.prevent="markAllRead"
                            ><p>Mark all as read</p></a
                        >
                    </div>
                    <div
                        class="c-notifications__wrap"
                        v-for="(notification, index) in notifications"
                    >
                        <a
                            href="#"
                            :class="[
                                'c-notifications',
                                notification.read === false ? 'new' : '',
                            ]"
                            :data-nid="notification.id"
                        >
                            <div class="c-notifications-wrap">
                                <div class="c-notifications-content">
                                    <div class="c-notifications-detail">
                                        <div class="c-avatar">
                                            <img
                                                :src="
                                                    notification.notifierAvatar
                                                "
                                                alt="avatar"
                                            />
                                        </div>
                                        <p>
                                            <template
                                                v-for="(
                                                    notifier, index
                                                ) in notification.notifiers"
                                            >
                                                <strong
                                                    v-if="index < 2"
                                                    :data-user="
                                                        '/u/' +
                                                        notifier.username
                                                    "
                                                    >{{
                                                        notifier.username
                                                    }}</strong
                                                >
                                                <span
                                                    v-if="
                                                        notification.notifiers
                                                            .length === 2 &&
                                                        index === 0
                                                    "
                                                    >and</span
                                                >
                                                <span
                                                    v-if="
                                                        notification.notifiers
                                                            .length > 2 &&
                                                        index === 0
                                                    "
                                                    >,</span
                                                >
                                                <span v-if="index === 2"
                                                    >and
                                                    {{
                                                        notification.notifiers
                                                            .length - 2
                                                    }}
                                                    other</span
                                                ><span
                                                    v-if="
                                                        notification.notifiers
                                                            .length > 3
                                                    "
                                                    >s</span
                                                >
                                            </template>
                                            <span>
                                                <img
                                                    v-if="
                                                        typeof notification.icon !=
                                                        'undefined'
                                                    "
                                                    :src="notification.icon"
                                                    alt=""
                                                />
                                                {{ notification.message }}
                                            </span>
                                        </p>
                                    </div>
                                    <div
                                        v-if="
                                            typeof notification.communityThumbnail !=
                                            'undefined'
                                        "
                                        class="c-notifications-community"
                                    >
                                        <img
                                            :src="$cdn('/img/communities/' + notification.communityId + '/' + notification.communityThumbnail)"
                                            alt="Community Image"
                                        />
                                        <p>
                                            {{ notification.communityName
                                            }}<small>{{
                                                notification.when
                                            }}</small>
                                        </p>
                                    </div>
                                </div>
                                <div
                                    class="c-panel__notification-btn"
                                    v-html="buttons[index]"
                                    @click.prevent="handleClick($event, index)"
                                ></div>
                            </div>
                            <div
                                v-if="
                                    typeof notification.article !=
                                        'undefined' &&
                                    notification.article !== ''
                                "
                                class="c-notifications-article"
                            >
                                <p>{{ notification.article.title }}</p>
                                <img
                                    v-if="notification.article.thumbnail"
                                    :src="
                                        $root.cloudinaryUrl +
                                        'c_fill,f_auto,g_center,h_128,dpr_' +
                                        $root.$dpr +
                                        ',q_auto/v1' +
                                        notification.article.thumbnail
                                    "
                                    alt="Notification Article"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    data() {
        return {
            notifications: this.$root.notifications,
            buttonDiv: null,
            cdnUrl: null,
        };
    },
    mounted() {},
    computed: {
        buttons() {
            let buttons = [];
            for (let i = 0; i < this.notifications.length; i++) {
                /*let ugcImg = this.notifications[i].button.match(/"(\/uploads\/.+?)"/);
                if (ugcImg && ugcImg.length === 2) {
                    let cdnUrl = '"' + this.cdnUrl.replace("/img/placeholder.jpg", ugcImg[1]) + '"';
                    buttons.push(this.notifications[i].button.replace(/"\/uploads\/.+?"/, cdnUrl));
                } else {
                    buttons.push(this.notifications[i].button);
                }*/
                buttons.push(this.notifications[i].button);
            }
            return buttons;
        },
    },
    methods: {
        follow(userId) {
            this.$simpleStore.follow(this, userId, false);
            let button = document.createElement("BUTTON");
            button.setAttribute("class", "c-btn3 c-btn--following");
            button.setAttribute("data-method", "unfollow");
            button.setAttribute("data-parameter", userId);
            button.textContent = "Following";
            this.buttonDiv.replaceChild(button, this.buttonDiv.childNodes[0]);
        },
        unfollow(userId) {
            this.$simpleStore.unfollow(this, userId, false);
            let button = document.createElement("BUTTON");
            button.setAttribute("class", "c-btn c-btn--follow");
            button.setAttribute("data-method", "follow");
            button.setAttribute("data-parameter", userId);
            button.textContent = "Follow";
            this.buttonDiv.replaceChild(button, this.buttonDiv.childNodes[0]);
        },
        handleClick(e, index) {
            // Call method dynamically if button click
            // method name set on button with data-method and data-parameter attributes on <button>
            if (e.target.tagName === "BUTTON") {
                this.buttonDiv = e.target.parentElement;
                this[e.target.dataset.method](e.target.dataset.parameter);
            }
        },
        markAllRead() {
            this.$http.post("/api/v1/notifications/read").then(
                (response) => {
                    if (response.data.success === true) {
                        let notices =
                            document.getElementsByClassName("c-notifications");
                        for (let i = 0; i < notices.length; i++) {
                            let nId = notices[i].dataset.nid;
                            notices[i].className = notices[i].className.replace(
                                " new",
                                ""
                            );
                        }
                    }
                },
                (response) => {
                    console.log("Error:");
                    console.log(response);
                }
            );
        },
    },
};
</script>
